import {Button} from 'reactstrap';
import classnames from '../../helpers/classnames';
import Translate from '../Translate/Translate';
import React from 'react';

export function ErrorRetryRequestButton(props: {
    label: string,
    disabled: boolean,
    onClickHandler: React.MouseEventHandler
}) {
    return <Translate
            tag={Button}
            message={props.label}
            className={classnames({
                'me-2': true,
                'opacity-50': props.disabled
            })}
            color="secondary"
            outline={true}
            onClick={props.onClickHandler}
            size="sm"
            disabled={props.disabled}
    />;
}
